var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "entertainment-ticket-2 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.785706 6.28571C0.785706 4.33299 2.3687 2.75 4.32142 2.75H17.6786C19.6312 2.75 21.2143 4.33299 21.2143 6.28571V8.11385C21.2143 8.27055 21.1211 8.41227 20.9773 8.47445C20 8.89693 19.3176 9.8692 19.3176 11C19.3176 12.1308 20 13.1031 20.9773 13.5255C21.1211 13.5877 21.2143 13.7294 21.2143 13.8861V15.7143C21.2143 17.667 19.6312 19.2501 17.6786 19.2501H4.32142C2.3687 19.2501 0.785706 17.667 0.785706 15.7143V13.8862C0.785706 13.7295 0.878841 13.5878 1.02269 13.5256C2 13.1032 2.68266 12.1309 2.68266 11C2.68266 9.86912 2 8.89682 1.02269 8.47437C0.878841 8.4122 0.785706 8.27048 0.785706 8.11377V6.28571ZM15.125 10.5613C15.125 10.0189 14.6853 9.57915 14.1428 9.57915C13.6004 9.57915 13.1607 10.0189 13.1607 10.5613V11.4395C13.1607 11.9819 13.6004 12.4216 14.1428 12.4216C14.6853 12.4216 15.125 11.9819 15.125 11.4395V10.5613ZM14.1428 4.74919C14.6853 4.74919 15.125 5.1889 15.125 5.73133V6.60951C15.125 7.15193 14.6853 7.59165 14.1428 7.59165C13.6004 7.59165 13.1607 7.15193 13.1607 6.60951V5.73133C13.1607 5.1889 13.6004 4.74919 14.1428 4.74919ZM15.125 15.3912C15.125 14.8488 14.6853 14.4091 14.1428 14.4091C13.6004 14.4091 13.1607 14.8488 13.1607 15.3912V16.2694C13.1607 16.8118 13.6004 17.2515 14.1428 17.2515C14.6853 17.2515 15.125 16.8118 15.125 16.2694V15.3912Z",
    fill: "#4E81F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.4f2ffccea8da994eeac01c3ccaac652b.svg";
export { ForwardRef as ReactComponent };